/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DefaultWidgetAppearanceSettingUi,
  FullWidgetAppearanceSettingUi,
  UpdateWidgetAppearanceSettingsRequest,
} from '../models';

export interface GetDefaultWidgetAppearanceSettingsRequest {
    botType: GetDefaultWidgetAppearanceSettingsBotTypeEnum;
    locale?: GetDefaultWidgetAppearanceSettingsLocaleEnum;
}

export interface GetWidgetAppearanceSettingsByPublicBotIdRequest {
    publicBotId: string;
}

export interface UpdateWidgetAppearanceSettingsOperationRequest {
    updateWidgetAppearanceSettingsRequest: UpdateWidgetAppearanceSettingsRequest;
}

/**
 * 
 */
export class WidgetAppearanceSettingsApiControllerApi extends runtime.BaseAPI {

    /**
     */
    async getDefaultWidgetAppearanceSettingsRaw(requestParameters: GetDefaultWidgetAppearanceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DefaultWidgetAppearanceSettingUi>> {
        if (requestParameters['botType'] == null) {
            throw new runtime.RequiredError(
                'botType',
                'Required parameter "botType" was null or undefined when calling getDefaultWidgetAppearanceSettings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/widget/appearance/default/{botType}`.replace(`{${"botType"}}`, encodeURIComponent(String(requestParameters['botType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getDefaultWidgetAppearanceSettings(requestParameters: GetDefaultWidgetAppearanceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DefaultWidgetAppearanceSettingUi> {
        const response = await this.getDefaultWidgetAppearanceSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getWidgetAppearanceSettingsByPublicBotIdRaw(requestParameters: GetWidgetAppearanceSettingsByPublicBotIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullWidgetAppearanceSettingUi>> {
        if (requestParameters['publicBotId'] == null) {
            throw new runtime.RequiredError(
                'publicBotId',
                'Required parameter "publicBotId" was null or undefined when calling getWidgetAppearanceSettingsByPublicBotId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/widget/appearance/{publicBotId}`.replace(`{${"publicBotId"}}`, encodeURIComponent(String(requestParameters['publicBotId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getWidgetAppearanceSettingsByPublicBotId(requestParameters: GetWidgetAppearanceSettingsByPublicBotIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullWidgetAppearanceSettingUi> {
        const response = await this.getWidgetAppearanceSettingsByPublicBotIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateWidgetAppearanceSettingsRaw(requestParameters: UpdateWidgetAppearanceSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullWidgetAppearanceSettingUi>> {
        if (requestParameters['updateWidgetAppearanceSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateWidgetAppearanceSettingsRequest',
                'Required parameter "updateWidgetAppearanceSettingsRequest" was null or undefined when calling updateWidgetAppearanceSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/widget/appearance`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateWidgetAppearanceSettingsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateWidgetAppearanceSettings(requestParameters: UpdateWidgetAppearanceSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullWidgetAppearanceSettingUi> {
        const response = await this.updateWidgetAppearanceSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetDefaultWidgetAppearanceSettingsBotTypeEnum = {
    AimeStarter: 'AIME_STARTER',
    AimeStock: 'AIME_STOCK',
    AimePx: 'AIME_PX',
    AimeFinance: 'AIME_FINANCE',
    AimeReservation: 'AIME_RESERVATION',
    TmcAime: 'TMC_AIME',
    AimeBuy: 'AIME_BUY'
} as const;
export type GetDefaultWidgetAppearanceSettingsBotTypeEnum = typeof GetDefaultWidgetAppearanceSettingsBotTypeEnum[keyof typeof GetDefaultWidgetAppearanceSettingsBotTypeEnum];
/**
 * @export
 */
export const GetDefaultWidgetAppearanceSettingsLocaleEnum = {
    EnGb: 'EN_GB',
    EnUs: 'EN_US',
    EnCa: 'EN_CA',
    FrFr: 'FR_FR',
    FrCa: 'FR_CA',
    DeDe: 'DE_DE',
    EsEs: 'ES_ES',
    JaJp: 'JA_JP',
    ArAe: 'AR_AE'
} as const;
export type GetDefaultWidgetAppearanceSettingsLocaleEnum = typeof GetDefaultWidgetAppearanceSettingsLocaleEnum[keyof typeof GetDefaultWidgetAppearanceSettingsLocaleEnum];
